export const linkIntelligenceGettingStartedArticle = {
  title: 'Link Intelligence Suite: Getting Started',
  slug: 'link-intelligence-getting-started',
  content: `Link Intelligence Suite: Getting Started

Create short links, QR codes, and link analytics from one hub.

1) Open Link Tools Hub
- Go to /link-tools-hub.
- Tabs use URL hashes (#shortener, #qrcode, #mylinks).

2) Create short links
- Use URL Shortener to add a destination URL and optional custom code.
- View analytics after creation.

3) Generate QR codes
- QR Code tab lets you customize size, colors, and optional shortening.

4) Manage links
- My Links lists saved links and analytics summaries.
`,
};
